module.exports = __webpack_public_path__ + "static/media/binaryTree.6c72d9f2.png";